/**
 * Closes any open dropdown by:
 * - Removing the `d-flex` class to hide the dropdown.
 * - Resetting the `left` CSS property.
 */
function closeDropdown() {
    $(".dropdown-content").removeClass("d-flex").css("left", "");
}

/**
 * Handles dropdown open/close and positioning logic.
 * @param {Event} e - The click event.
 * @param {jQuery} $button - The button that triggered the dropdown.
 */
function handleDropdownClick(e, $button) {
    e.stopPropagation();

    const $dropdownMenu = $button.closest(".js-dropdown-menu");
    const $dropdownContent = $dropdownMenu.find(".js-dropdown-content");
    const isVisible = $dropdownContent.hasClass("d-flex");
    if (isVisible) {
        $dropdownContent.removeClass("d-flex").css("left", "");
        return;
    }
    // Temporarily show to measure
    $dropdownContent
        .addClass("d-flex")
        .css({
            visibility: "hidden",
            left: "0"
        });

    setTimeout(() => {
        const dropdownOffset = $dropdownContent.offset();
        const dropdownWidth = $dropdownContent.outerWidth();
        const buttonOffset = $button.offset();
        const buttonWidth = $button.outerWidth();
        const viewportWidth = $(window).width();
        const rightEdge = dropdownOffset.left + dropdownWidth;

        let newLeft = 0;

        if (rightEdge > viewportWidth) {
            newLeft = buttonOffset.left + buttonWidth - dropdownWidth;
            if (newLeft < 0) {
                newLeft = 0;
            }
            $dropdownContent.css("left", newLeft - buttonOffset.left + "px");
        } else {
            $dropdownContent.css("left", "0");
        }

        $dropdownContent.css("visibility", "visible");

        // Scroll into view if needed
        const dropdownBottom = $dropdownContent.offset().top + $dropdownContent.outerHeight();
        const scrollBottom = $(window).scrollTop() + $(window).height();
        if (dropdownBottom > scrollBottom) {
            $("html, body").animate({
                scrollTop: dropdownBottom - $(window).height() + 20
            }, 400, "swing");
        }
    }, 30);
}

/**
 * Resets all open collapsible sections except category and availability.
 */
function resetCollapsibleSections() {
    $(".collapsible-xxl.active:not(.d-none)").each(function () {
        const $section = $(this);
        const isCategory = $section.hasClass("refinement-category") && $section.hasClass("js-category");
        const isAvailability = $section.hasClass("refinement-oos") && $section.hasClass("js-availability");
        if (isCategory || isAvailability) {
            return;
        }
        $section.removeClass("active");
        $section.attr("aria-expanded", "false");
        $section.css("min-height", "");
        $section.find(".collapsible-header button").attr("aria-expanded", "false");
        $section.find(".collapsible-body").slideUp();
    });
}

module.exports = {
    closeDropdown: closeDropdown,
    handleDropdownClick: handleDropdownClick,
    resetCollapsibleSections: resetCollapsibleSections
};
